import { render, staticRenderFns } from "./ReorderButton.vue?vue&type=template&id=ae3bf054&"
import script from "./ReorderButton.ts?vue&type=script&lang=ts&"
export * from "./ReorderButton.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports